import { FC } from 'react';

type Props = {
	className?: string;
};

const DropletIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M3.19922 11.3422C3.19922 7.99497 6.06379 4.6872 8.07442 2.77776C9.16638 1.74075 10.8318 1.74075 11.9238 2.77776C13.9344 4.6872 16.7989 7.99497 16.7989 11.3422C16.7989 14.6241 14.224 17.9997 9.99908 17.9997C5.77419 17.9997 3.19922 14.6241 3.19922 11.3422Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M13.1999 11.5996C13.1999 13.3669 11.7672 14.7995 10 14.7995'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default DropletIcon;
